import axios from 'axios';

axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('token')}`;

// export async function login(email: string, password: string) {
//   const response = await axios.post('/api/login/', { email, password });
//   const { token } = response.data;
//   localStorage.setItem('token', token);
//   axios.defaults.headers.common['Authorization'] = `Token ${token}`;
// }

export const login = async (email: string, password: string) => {
    // if (email === "clinic_s@chart.com" && password === "loginSystem") {
    //     return {
    //         location: "Clinic S2",
    //         location_id: 12
    //     }
    // } else if (email === "fever_extension@chart.com" && password === "loginSystem") {
    //     return {
    //         location: "Fever Ext2",
    //         location_id: 11
    //     }
    // } else if (email === "pharmacy@chart.com" && password === "loginSystem") {
    //     return {
    //         location: "Pharmacy2",
    //         location_id: 13
    //     }
    // } else {
    //     return {
    //         location: "Standby2",
    //         location_id: 14
    //     }
    // }
    if (email === "test@autove.ai" && password === "1234") {
        return {
            // testing
            // location: "elevator",
            // location_id: 17

            // deployment
            location: "Pharmacy",
            location_id: -1
        }
    } else {
        return {
            //testing
            location: "Login",
            location_id: -1

            // deployment
            // location: "chargeCGH",
            // location_id: 26
        }
    }
}